import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// context
import { MatchContext } from "../providers/match";
// service
import { getRoommatesRoom } from "../utils/services/roommates";

const STEPS = [
  { step: 1, label: "Quarto", path: "/select" },
  { step: 2, label: "Companhia", path: "/match" },
  { step: 3, label: "Convidar", path: "/participants" },
];

export default function Stepper({ currentStep, t = (s) => s, activeColor }) {
  const [disableOptions, setDisableOptions] = useState(false);
  const navigate = useNavigate();
  // context
  const { matchConfig, idEvent, idParticipant, roomSize } =
    React.useContext(MatchContext);

  function goToStep(step, path) {
    // só permite voltar para etapas já concluídas, nunca pular pra frente
    if (step >= currentStep) return;

    navigate({ pathname: path, search: window.location.search });
  }

  async function validRoomUser() {
    try {
      const res = await getRoommatesRoom(idEvent, idParticipant);

      if (res?.data?.roomSize > 0) {
        setDisableOptions(true);
      } else {
        setDisableOptions(false);
      }
    } catch (error) {
      console.log({ error });
      setDisableOptions(false);
    }
  }

  useEffect(() => {
    validRoomUser();
  }, []);

  if (roomSize < 2) return;
  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <h4 style={{ color: "white", marginBottom: 10 }}>
        {matchConfig?.event?.title ?? ""}
      </h4>

      <div className="app-stepper">
        {STEPS.map(({ step, label, path }, index) => {
          const isForcedDone = disableOptions && (step === 1 || step === 3);
          const isActive = step === currentStep && !isForcedDone;
          const isDone = step < currentStep || isForcedDone;
          const isClickable = isDone && !isForcedDone;

          return (
            <React.Fragment key={step}>
              {index > 0 && (
                <div
                  className={
                    "app-stepper-line" +
                    (step <= currentStep ? " app-stepper-line-filled" : "")
                  }
                />
              )}
              <div
                className={
                  "app-stepper-item" +
                  (isActive ? " app-stepper-item-active" : "") +
                  (isClickable ? " app-stepper-item-clickable" : "") +
                  (isForcedDone ? " app-stepper-item-disabled" : "")
                }
                onClick={() => {
                  if (isClickable) goToStep(step, path);
                }}
                onKeyDown={(e) => {
                  if (isClickable && (e.key === "Enter" || e.key === " ")) {
                    e.preventDefault();
                    goToStep(step, path);
                  }
                }}
                role={isClickable ? "button" : undefined}
                tabIndex={isClickable ? 0 : undefined}
                aria-current={isActive ? "step" : undefined}
                aria-disabled={isForcedDone ? true : undefined}
                aria-label={`Etapa ${step} de ${STEPS.length}: ${t(label)}${
                  isDone ? " (concluída)" : isActive ? " (atual)" : ""
                }`}
              >
                <span
                  className={
                    "app-stepper-circle" +
                    (isActive || isDone ? " app-stepper-circle-filled" : "")
                  }
                  style={
                    (isActive || isDone) && activeColor && !isForcedDone
                      ? { backgroundColor: "white", color: activeColor }
                      : undefined
                  }
                >
                  {isDone ? (
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      aria-hidden="true"
                    >
                      <path
                        d="M2 6L5 9L10 3"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : (
                    step
                  )}
                </span>
                <span className="app-stepper-label">{t(label)}</span>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
